import React from 'react';
import FacebookIcon from './FacebookIcon';
import LinkedinIcon from './LinkedinIcon';
import TwitterIcon from './TwitterIcon';
import InstagramIcon from './InstagramIcon';
import YouTubeIcon from './YouTubeIcon';
import WebIcon from './WebIcon';
import './SocialIcon.css'
import logComponent from '../../common/logComponent';

export default function SocialIcon({ type, link, style, className }) {
  if (logComponent('SocialIcon')) { console.debug('SocialIcon rendered'); }
  let icon = '';
  
  switch(type) {
    case 'F':
    case 'facebook':
      icon = <FacebookIcon className={'Social-Icon ' + className} style={style} link={link} />;
      break;
    case 'L':
    case 'linkedin':
      icon = <LinkedinIcon className={'Social-Icon ' + className} style={style} link={link} />;
      break;
    case 'T': 
    case 'twitter':
      icon = <TwitterIcon className={'Social-Icon ' + className} style={style} link={link} />;
      break;
    case 'I':
    case 'instagram':
      icon = <InstagramIcon className={'Social-Icon ' + className} style={style} link={link} />;
      break;
    case 'Y':
    case 'youtube':
      icon = <YouTubeIcon className={'Social-Icon ' + className} style={style} link={link} />;
      break;
    case 'W':
    case 'web':
      icon = <WebIcon className={'Social-Icon ' + className} style={style} link={link} />; 
      break;
    default:
      break;
  }

  return icon;
}